const translationKeys = {
  bankid_youth_header_title: 'bankid_youth_header_title',
  bankid_youth_process_summary_message: 'bankid_youth_process_summary_message',
  bankid_youth_information_section_title:
    'bankid_youth_information_section_title',
  bankid_youth_start_application_button:
    'bankid_youth_start_application_button',
  bankid_youth_application_requirement_age_title:
    'bankid_youth_application_requirement_age_title',
  bankid_youth_application_requirement_age_message:
    'bankid_youth_application_requirement_age_message',
  bankid_youth_application_requirement_account_title:
    'bankid_youth_application_requirement_account_title',
  bankid_youth_application_requirement_account_message:
    'bankid_youth_application_requirement_account_message',
  bankid_youth_application_requirement_passport_title:
    'bankid_youth_application_requirement_passport_title',
  bankid_youth_application_requirement_passport_message:
    'bankid_youth_application_requirement_passport_message',
  bankid_youth_application_requirement_bankid_title:
    'bankid_youth_application_requirement_bankid_title',
  bankid_youth_application_requirement_bankid_message:
    'bankid_youth_application_requirement_bankid_message',
  bankid_youth_application_requirement_ssn_title:
    'bankid_youth_application_requirement_ssn_title',
  bankid_youth_application_requirement_ssn_message:
    'bankid_youth_application_requirement_ssn_message',
  bankid_youth_application_save_error_title:
    'bankid_youth_application_save_error_title',
  bankid_youth_application_save_error_message:
    'bankid_youth_application_save_error_message',
  bankid_youth_application_save_error_back_button:
    'bankid_youth_application_save_error_back_button',
  bankid_youth_application_save_error_try_again_button:
    'bankid_youth_application_save_error_try_again_button',
  bankid_youth_application_save_success_title:
    'bankid_youth_application_save_success_title',
  bankid_youth_application_save_success_message:
    'bankid_youth_application_save_success_message',
  bankid_youth_application_about_young_ssn_label:
    'bankid_youth_application_about_young_ssn_label',
  bankid_youth_application_about_young_firstname_label:
    'bankid_youth_application_about_young_firstname_label',
  bankid_youth_application_about_young_lastname_label:
    'bankid_youth_application_about_young_lastname_label',
  bankid_youth_application_about_young_title:
    'bankid_youth_application_about_young_title',
  bankid_youth_application_about_guardians_title:
    'bankid_youth_application_about_guardians_title',
  bankid_youth_application_about_guardians_has_multiple_label:
    'bankid_youth_application_about_guardians_has_multiple_label',
  bankid_youth_application_about_guardians_ssn_label:
    'bankid_youth_application_about_guardians_ssn_label',
  bankid_youth_application_about_guardians_firstname_label:
    'bankid_youth_application_about_guardians_firstname_label',
  bankid_youth_application_about_guardians_lastname_label:
    'bankid_youth_application_about_guardians_lastname_label',
  bankid_youth_application_about_guardians_email_label:
    'bankid_youth_application_about_guardians_email_label',
  bankid_youth_application_about_guardians_phone_label:
    'bankid_youth_application_about_guardians_phone_label',
  bankid_youth_application_multiple_guardians_info_title:
    'bankid_youth_application_multiple_guardians_info_title',
  bankid_youth_application_multiple_guardians_info_text:
    'bankid_youth_application_multiple_guardians_info_text',
  bankid_youth_application_single_guardian_info_text:
    'bankid_youth_application_single_guardian_info_text',
  bankid_youth_application_single_guardian_info_title:
    'bankid_youth_application_single_guardian_info_title',
  bankid_youth_application_step_personal_information_label:
    'bankid_youth_application_step_personal_information_label',
  bankid_youth_application_step_summary_label:
    'bankid_youth_application_step_summary_label',
  bankid_youth_application_loading_text:
    'bankid_youth_application_loading_text',
  bankid_youth_application_loading_error_title:
    'bankid_youth_application_loading_error_title',
  bankid_youth_application_loading_error_message:
    'bankid_youth_application_loading_error_message',
  bankid_youth_application_save_success_details_title:
    'bankid_youth_application_save_success_details_title',
};

Object.freeze(translationKeys);

export default translationKeys;
